import script from "./AuthorizeDeviceDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthorizeDeviceDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./AuthorizeDeviceDrawer.vue?vue&type=style&index=0&id=cc67670a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc67670a"]])

export default __exports__